import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'title/abstract' },
  { name: 'title' },
  { name: 'abstract' },
  { name: 'authors' }
]

const defaultSyntaxGuideUrl = 'https://www.epistemonikos.org/en/about_us/how_to_use#advanced-search'

class EpistemonikosEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('Epistemonikos')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  formulateQuery (query) {
    return 'https://www.epistemonikos.org/advanced_search?q=' + encodeURIComponent(query)
  }
  formulateQueryFromNodeData (nodeData) {
    const baseTerm = nodeData.text.replace(SearchEngine.quoteReplaceRE, '\\"')
    const addQuotes = this.addQuotesAroundPhrases && baseTerm && baseTerm.indexOf(' ') > 0
    return this.formTerm(baseTerm, nodeData.isNegative, addQuotes,
      nodeData.fieldSpecifier)
  }
  formTerm (text, isNegative, addQuotes, fieldSpecifier) {
    let r = ''
    if (isNegative) {
      r += 'NOT '
    }
    if (addQuotes) {
      r += '"'
    }
    if (fieldSpecifier && fieldSpecifier.length > 0) {
      if (fieldSpecifier.toLowerCase() === 'title/abstract') {
        r += `(title:(${text}) OR abstract:(${text}))`
      } else {
        r += `${fieldSpecifier}:(${text})`
      }
    } else {
      r += text
    }
    if (addQuotes) {
      r += '"'
    }
    return r
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsMeshSettings()
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }
}

export default EpistemonikosEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/EpistemonikosEngine.js